import * as Sentry from "@sentry/react";

function ErrorMessage({
  error,
  reset: _,
}: {
  error: Error;
  reset: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="text-red-500 p-5">
        Something went wrong on our end. We've been notified and will take a
        look at what went wrong. In the meantime, you can refresh the page and
        try again.
      </div>
      <div className="text-red-500 p-5">Error: {error.message}</div>
    </div>
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withErrorBoundary<P extends Record<string, any>>(
  WrappedComponent: React.ComponentType<P>,
) {
  return Sentry.withErrorBoundary(WrappedComponent, {
    fallback: (errorData) => (
      <ErrorMessage
        error={errorData.error as Error}
        reset={errorData.resetError}
      />
    ),
  });
}
